import { z } from "zod";
import { highMobilityConnectionPlanSchema, telemetryDataProviderSchema } from "../_shared";

export const requestVehicleConnectionRequestPayload = z.object({
  companyUuid: z.uuid(),
  companyGroupUuid: z.uuid(),
  companyName: z.string(),
  requestedConnectionBy: z.string(),
  connectionPlan: highMobilityConnectionPlanSchema,
  vehicles: z.array(
    z.object({
      registrationNumber: z.string(),
      uuid: z.uuid(),
      dataProvider: telemetryDataProviderSchema,
    }),
  ),
});

export type RequestVehicleConnectionRequestPayload = z.infer<
  typeof requestVehicleConnectionRequestPayload
>;
